export const environment = {
  production: true,
  meetingServiceRootUrl: 'https://api.vcircle.ng/',
  proctorServiceRootUrl: '//proctorservices.webtest.ng/',
  mediasoupScheme: 'https',
  aiServerUrl: 'https://aiproctor.webtest.ng/',
  s3passportbucketurl :"https://cbtpassportstorage.s3.us-west-2.amazonaws.com/",
  quitseburl: "https://webtest.ng",
  maxRequestRetries: 3,
  secondViewProctorDomain: 'secondview.webtest.ng',
  isMac: ((navigator as any).userAgentData?.platform ?? navigator.platform).toLowerCase().startsWith('mac')
};
